import Image from "../Layout/Image";

const NavBgHeader = () => {
  return (
    <div className="first">
      <h3>Free Seminar</h3>
      <div>
        <Image name="gel.png" altText="Cart icon" />
      </div>
    </div>
  );
};

export default NavBgHeader;
